<app-input-label
  [isRequired]="isRequired"
  [label]="label"
  [inputId]="inputId"
></app-input-label>

<mat-form-field class="form-control date-input text-sm mt-1">
  <input
    matInput
    readonly
    [matDatepicker]="picker"
    [id]="inputId"
    [formControl]="control"
    [placeholder]="placeholder"
    [min]="minDate"
    [max]="maxDate"
  />
  <mat-datepicker-toggle matIconSuffix [for]="picker"> </mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>

@if(control.touched){
<p
  [dynamicErrorMsg]="control"
  [label]="label"
  class="text-xs text-danger mt-1 mb-0"
></p>
}
